import { render, staticRenderFns } from "./ModalCrudForm.vue?vue&type=template&id=2e99a3dc&scoped=true&"
import script from "./ModalCrudForm.vue?vue&type=script&lang=js&"
export * from "./ModalCrudForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalCrudForm.vue?vue&type=style&index=0&id=2e99a3dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e99a3dc",
  null
  
)

export default component.exports